module.exports = __webpack_public_path__ + "img/radius-bottomright.8fdf43c8.svg";